import type { EquipmentInfo } from '@az3fr/core';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const equipmentAdapter = createEntityAdapter<EquipmentInfo>();

const equipmentSlice = createSlice({
	name: 'entities/equipment',
	initialState: equipmentAdapter.getInitialState(),
	reducers: {
		setAll: equipmentAdapter.setAll,
	},
});
type EquipmentSliceState = ReturnType<typeof equipmentAdapter.getInitialState>;

const equipmentSliceActions = { ...equipmentSlice.actions };
const equipmentSliceReducer = equipmentSlice.reducer;

export { equipmentSliceActions, equipmentSliceReducer, equipmentAdapter };
export type { EquipmentSliceState };
